import type { OfflineEntity } from './db'
import { queryClient } from '../queryClient'

type CachedPage = { data?: unknown[] }

const ID_FIELD: Partial<Record<OfflineEntity, string>> = {
  stoppage: 'stoppageId',
  geoRehandle: 'geoRehandleId',
  loading: 'loadingId',
  diggingPattern: 'diggingPatternId',
  drillingPattern: 'drillingBlastId',
  drillingLine: 'id',
}

export function patchCachedRowVersion(
  entity: OfflineEntity,
  entityId: number | undefined,
  rowVersion: string | undefined,
): void {
  const idField = ID_FIELD[entity]
  if (!idField || !entityId || !rowVersion) return

  const matches = (row: unknown): boolean =>
    !!row && typeof row === 'object' && (row as Record<string, unknown>)[idField] === entityId

  for (const [key, cached] of queryClient.getQueriesData<CachedPage>({ queryKey: ['dataTable'] })) {
    const rows = cached?.data
    if (!Array.isArray(rows) || !rows.some(matches)) continue

    queryClient.setQueryData(key, {
      ...cached,
      data: rows.map(row => matches(row)
        ? Object.assign(Object.create(Object.getPrototypeOf(row)), row, { rowVersion })
        : row),
    })
  }
}

export function patchCachedEntityId(
  entity: OfflineEntity,
  tempId: number | undefined,
  serverId: number | undefined,
): void {
  const idField = ID_FIELD[entity]
  if (!idField || !tempId || !serverId || tempId >= 0) return

  const matches = (row: unknown): boolean =>
    !!row && typeof row === 'object' && (row as Record<string, unknown>)[idField] === tempId

  for (const [key, cached] of queryClient.getQueriesData<CachedPage>({ queryKey: ['dataTable'] })) {
    const rows = cached?.data
    if (!Array.isArray(rows) || !rows.some(matches)) continue

    queryClient.setQueryData(key, {
      ...cached,
      data: rows.map(row => (matches(row) ? { ...(row as object), [idField]: serverId } : row)),
    })
  }
}
